/* eslint-disable react/jsx-wrap-multilines */
import { Common, color, Widget } from '@stockbit/ui';
import { Modal } from '../styled';

const { Text, Flex } = Common;
const { Button } = Widget;

interface ValuationModalDeleteTypes {
  valuationId: number;
  valuationName: string;
  isVisible: boolean;
  onCancel: () => void;
  onSubmit: (data: number) => void;
  isLoading: boolean;
}

const ValuationModalDelete = ({
  valuationId,
  valuationName,
  isVisible,
  onCancel,
  onSubmit,
  isLoading,
}: ValuationModalDeleteTypes) => (
  <Modal
    title={
      <Text size="18px" align="center" height="40px" family="bold">
        Delete Valuation
      </Text>
    }
    visible={isVisible}
    onCancel={onCancel}
    centered
    footer={null}
  >
    <Text>
      Are you sure you want to delete &quot;{valuationName}&quot; valuation?
    </Text>
    <Flex justify="flex-end" mt="15px">
      <Button height="40px" borderLess onClick={onCancel}>
        <Text>CANCEL</Text>
      </Button>
      <Button
        loading={isLoading}
        type="primary"
        height="40px"
        width="80px"
        round
        onClick={() => onSubmit(valuationId)}
      >
        <Text color={color.light} align="center">
          {!isLoading && 'DELETE'}
        </Text>
      </Button>
    </Flex>
  </Modal>
);

export default ValuationModalDelete;
